import BaseApi from 'api/core/baseApi';
import { ENDPOINTS } from 'api/config/endpoints';

class SearchApi extends BaseApi {
  constructor() {
    super(ENDPOINTS.SEARCH);
  }

  getSearchResultOfOrders(params = new URLSearchParams()) {
    const queryString = params.toString();

    return this.httpClient.get(
      `${this.getResourceUrl()}orders/?${queryString}`,
    );
  }

  getSearchResultOfProducts(params = new URLSearchParams()) {
    const queryString = params.toString();

    return this.httpClient.get(
      `${this.getResourceUrl()}products/?${queryString}`,
    );
  }

  getSearchResultOfManifests(params = new URLSearchParams()) {
    const queryString = params.toString();

    return this.httpClient.get(
      `${this.getResourceUrl()}manifests/?${queryString}`,
    );
  }
}

export default new SearchApi();
